import { ITEM_GROUP_INITIAL_STATE } from './chunk-RSPEMSKN.mjs';
import { ITEM_INITIAL_STATE_FOR_SAVING, ITEM_INITIAL_STATE } from './chunk-IGSXE2BX.mjs';
import { MENU_TYPE_INITIAL_STATE } from './chunk-SSUWACGU.mjs';
import { MODIFIER_GROUPS_INITIAL_STATE } from './chunk-TOUCFDN5.mjs';
import { MODIFIER_ITEM_INITIAL_STATE } from './chunk-3A2KG5LI.mjs';
import { REPORTING_GROUP_INITIAL_STATE } from './chunk-6BKQGMKT.mjs';
import { SPECIAL_INITIAL_STATE_FOR_SAVING, SPECIAL_INITIAL_STATE } from './chunk-NXTTVEZZ.mjs';
import { CATEGORIES_INITIAL_STATE } from './chunk-VRPWZYYT.mjs';
import { COMBO_INITIAL_STATE_FOR_SAVING, COMBO_INITIAL_STATE } from './chunk-HQDB7QW6.mjs';
import { DISCOUNT_INITIAL_STATE } from './chunk-SYWTGWBZ.mjs';
import { INGREDIENT_INITIAL_STATE } from './chunk-VSPEQRDU.mjs';
import { SUBCATEGORY_INITIAL_STATE } from './chunk-YTGMKKOP.mjs';
import { __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/index.ts
var getMenuInitialState = (bucketSelected, prefillData = void 0) => {
  const getInitialState = () => {
    switch (bucketSelected) {
      case "items": {
        return ITEM_INITIAL_STATE;
      }
      case "menuTypes": {
        return MENU_TYPE_INITIAL_STATE;
      }
      case "categories": {
        return CATEGORIES_INITIAL_STATE;
      }
      case "subcategories": {
        return SUBCATEGORY_INITIAL_STATE;
      }
      case "modifierGroups": {
        return MODIFIER_GROUPS_INITIAL_STATE;
      }
      case "modifierItems": {
        return MODIFIER_ITEM_INITIAL_STATE;
      }
      case "discounts": {
        return DISCOUNT_INITIAL_STATE;
      }
      case "combos": {
        return COMBO_INITIAL_STATE;
      }
      case "specials": {
        return SPECIAL_INITIAL_STATE;
      }
      case "ingredients": {
        return INGREDIENT_INITIAL_STATE;
      }
      case "itemGroups": {
        return ITEM_GROUP_INITIAL_STATE;
      }
      case "reportingGroups": {
        return REPORTING_GROUP_INITIAL_STATE;
      }
    }
  };
  const initialState = getInitialState();
  if (prefillData) {
    return __spreadValues(__spreadValues({}, initialState), prefillData);
  }
  return initialState;
};
var getMenuInitialStateForSaving = (bucketSelected) => {
  switch (bucketSelected) {
    case "items": {
      return ITEM_INITIAL_STATE_FOR_SAVING;
    }
    case "combos": {
      return COMBO_INITIAL_STATE_FOR_SAVING;
    }
    case "specials": {
      return SPECIAL_INITIAL_STATE_FOR_SAVING;
    }
    default:
      return getMenuInitialState(bucketSelected);
  }
};

export { getMenuInitialState, getMenuInitialStateForSaving };
